export default {
    'ERROR-GET-PROSPECT-RELATION': {
        'RELATION-ID-OR-PROSPECT-ID-MISSING': {
            actionType: 'toast',
            message: {
                fr: 'Impossible de récupérer la relation : identifiant manquant.',
                en: 'Cannot fetch relation: missing identifier.',
            },
        },
        'NO-RELATION-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Relation introuvable.",
                en: 'Relation not found.',
            },
            redirectPath: '/',
        },
        'RELATION-ID-MISMATCH-PROSPECT-ID': {
            actionType: 'redirect',
            message: {
                fr: "La relation ne correspond pas.",
                en: 'Relation does not match.',
            },
            redirectPath: '/',
        },
        'NO-HELPER-ID-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "L'ambassadeur lié est introuvable.",
                en: 'Linked ambassador not found.',
            },
            redirectPath: '/',
        },
        'NO-CAMPAIGN-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Campagne introuvable pour cette relation.",
                en: 'Campaign not found for this relation.',
            },
            redirectPath: '/',
        },
        'NO-HELPER-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "L'ambassadeur associé est introuvable.",
                en: 'Associated ambassador not found.',
            },
            redirectPath: '/',
        },
        'NO-RELATION-MOMENT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Erreur lors de la récupération d'une étape de la relation.",
                en: 'Error retrieving a step of the relation.',
            },
        },
    },
    'ERROR-REPORT-HELPER': {
        'INVALID-REPORT': {
            actionType: 'toast',
            message: {
                fr: 'Le rapport est invalide.',
                en: 'Invalid report format.',
            },
        },
        'MISSING-REPORT-FIELDS': {
            actionType: 'toast',
            message: {
                fr: 'Certains champs obligatoires sont manquants pour envoyer le rapport.',
                en: 'Some required fields are missing for the report.',
            },
        },
        'INVALID-REPORT-REASON': {
            actionType: 'toast',
            message: {
                fr: 'La raison du rapport est invalide.',
                en: 'Invalid report reason.',
            },
        },
        'RELATION-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Relation introuvable pour envoyer un rapport.",
                en: 'Relation not found to submit a report.',
            },
            redirectPath: '/',
        },
        'RELATION-ALREADY-REPORTED': {
            actionType: 'toast',
            message: {
                fr: 'Vous avez déjà signalé cet ambassadeur.',
                en: 'You have already reported this ambassador.',
            },
        },
    },
};
